import styled from "styled-components"
import useDaumPostCode from "hooks/shipping/useDaumPostCode"

export default function DaumPostCode({ visible, setVisible, onComplete, zIndex = 600 }) {
  const { kakaoWrapId } = useDaumPostCode({ onComplete })

  return <SearchWrapper id={kakaoWrapId}></SearchWrapper>
}

export const SearchWrapper = styled.div`
  height: 100%;
`
